/*
 */
<template>
</template>
<script>
export default {
	mixins: [
		require('js/common/url.mixin.vue'),
	],
	props:[
		'r_settings',
		'r_messages',
	],
	data: function(){
		return {
			//! デフォルト検索パラメータ
			m_arrSearchParamDefault:{}
		};
	},
	computed:{
	},
	methods: {
		//! 初期化イベント
		onInitialize: function(){
		},
	},
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts/login/Manager.vue